import { ReactNode } from 'react'
import './ValidationMessage.less'

interface ValidationMessageProps {
  invalidMessage: string | null
  className?: string
  children: ReactNode
}

const ValidationMessage = ({
  className,
  invalidMessage,
  children,
}: ValidationMessageProps): JSX.Element => (
  <span
    className={`validation-wrapper ${className ?? ''} ${invalidMessage ? 'show-validity' : ''}`}>
    {children}
    <strong aria-live='polite' className='error-message'>
      {invalidMessage}
    </strong>
  </span>
)

export default ValidationMessage
